jQuery(function($) {
	jQuery(document).ready(function() {
		
		// Blog Image FigCaption Fix
			$('.wp-block-image').each(function() {
				var blogFigure = $('.wp-block-image > figure').width();
				//console.log(blogFigure);
				$(this).find('figcaption').css({
					"width": blogFigure,
				});
			});
			
		
		// Nav Search
			var navSearch = $('.nav-search');
			navSearch.replaceWith('<div class="nav-search"><i class="far fa-search"></i></div>');
			$('.nav-search').click(function(e) {
				e.preventDefault();
				if($('.block-site-search').hasClass('is-active')) {
					$('.block-site-search').removeClass('is-active');
				} else {
					$('.block-site-search').addClass('is-active');
				}
				//$('.block-site-search').addClass('is-active');
				if($(".hamburger").hasClass('is-active')) {
					$(".hamburger").removeClass('is-active');
					$("#mobile-menu").removeClass('is-active');
				}
				if($('header.header').hasClass('is-active')) {
					$('header.header').removeClass('is-active');
				} else {
					$('header.header').addClass('is-active');
				}
			});

		// Hamburger Menu
			var $hamburger = $(".hamburger");
			$hamburger.on("click", function(e) {
				$hamburger.toggleClass("is-active");
				$('.block-site-search').removeClass('is-active');
				// Toggle Main Nav sticky
				if($($hamburger).hasClass('is-active')) {
					$('header.header').addClass('is-active');
				} else {
					$('header.header').removeClass('is-active');
				}
				//$('header.header').toggleClass('is-active');
			});
/*
			$('#mobile-menu a').click(function(e) {
				$hamburger.toggleClass("is-active");
				$('#mobile-menu').foundation('toggle'); 
				$('header.header').toggleClass('is-active');
			});
*/
			
		// Loadmore	
			$(".moreBox").slice(0, 4).show();
			if ($(".blogBox:hidden").length != 0) {
				$("#loadMore").show();
			}   
			$("#loadMore").on('click', function (e) {
				e.preventDefault();
				$(".moreBox:hidden").slice(0, 4).slideDown();
				if ($(".moreBox:hidden").length == 0) {
					$("#loadMore").fadeOut('slow');
				}
			});
			
		// Header Stick
			$(document).on('scroll', function () {
				// if the scroll distance is greater than 100px
				if ($(window).scrollTop() > 0) {
					// console.log('heylldidf');
					$('.head-stick').addClass('pinned');
				} else {
					$('.head-stick').removeClass('pinned');
				}
			});
			
			
		// Slider
			$('.slider-home').slick({
				dots: true,
				customPaging: function(slider, i) {
					//var name = network[i];
					return '<div class="item-dot"></div>';
			    },
				arrows: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				nextArrow: '<span class="nav-arrow arrow-right"></span>',
				prevArrow: '<span class="nav-arrow arrow-left"></span>',
				//prevArrow: $(".prev"),
				//nextArrow: $(".next"),
				//useCSS: false,
				//useTransform: false,
				waitForAnimate: false,
				speed: 0,
				draggable: false,
				responsive: [
				    {
				      breakpoint: 640,
				      settings: {
				        arrows: false,
				      }
				    }
				  ]
			});	
			$('.slider-home-v2').slick({
				dots: true,
				customPaging: function(slider, i) {
					//var name = network[i];
					return '<div class="item-dot"></div>';
			    },
				arrows: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				nextArrow: '<span class="nav-arrow arrow-right"></span>',
				prevArrow: '<span class="nav-arrow arrow-left"></span>',
				//prevArrow: $(".prev"),
				//nextArrow: $(".next"),
				//useCSS: false,
				//useTransform: false,
				waitForAnimate: false,
				speed: 0,
				draggable: true,
				responsive: [
				    {
				      breakpoint: 640,
				      settings: {
				        arrows: false,
				      }
				    }
				  ]
			});	
			
			$('.slider-vid').each(function() {
				$(this).slick({
					dots: false,
					arrows: true,
					slidesToShow: 4,
					slidesToScroll: 1,
					infinite: false,
					nextArrow: '<span class="nav-arrow arrow-right"></span>',
					prevArrow: '<span class="nav-arrow arrow-left"></span>',
					responsive: [
					    {
							breakpoint: 640,
							settings: {
								slidesToShow: 1,
								centerMode: true,
							}
					    },
					     {
							breakpoint: 1440,
							settings: {
								slidesToShow: 3,
							}
					    },
					    {
							breakpoint: 1024,
							settings: {
								slidesToShow: 2,
							}
					    }
					  ]
				});
			});
			
			
		// Waypoints	
			$('.animate-in').waypoint({
			    handler: function(direction) {
			        $(this[0,'element']).addClass('animated');
			    },
			    offset: '88%'
			});	
			
			$('.count-in').waypoint({
			    handler: function(direction) {
			        $(this[0,'element']).addClass('animated');
			    },
			    offset: '88%'
			});	
			
		// Check UTM Params
			const params = new URLSearchParams(window.location.search);
			if(params.has('utm_open') && params.has('utm_source')) {
				const source = params.get('utm_open');
				if(source == 'form') {
					$('#globalSignupModal').foundation('open');
				}
			}
			if(params.has('utm_source')) {
				const utm_source = params.get('utm_source');
				if(utm_source == 'email') {
					$('#postModal').foundation('open');
				}
			}
			window.addEventListener('message', event => {
			   if(event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted') {
			       $('#postModal').foundation('close');
			   }
			});

			//if source
			if(params.has('utm_open')) {
				const source = params.get('utm_open');
				if(source == 'form') {
					$('#globalSignupModal').foundation('open');
				}
			}

			if(params.has('social')) {
				const source = params.get('social');
				if(source == 'active') {
					$('#globalSocialModal').foundation('open');
				}
			}

			// Close Social Modal
			window.addEventListener('message', event => {
				if(event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmit') {
					$('#globalSocialModal').foundation('close');
				}
			});
			
			

			function dlToggle() {
				let dlTerms = document.querySelectorAll('.js-dl-toggle');
			
				dlTerms.forEach(function(term) {
						term.addEventListener('click', (event) => {
							/*term.classList.toggle('active');*/
			
							let termParent = term.parentElement;
							termParent.classList.toggle('active');
			
							let termSibling = term.nextElementSibling;
							if (!termSibling.classList.contains('active')) {
					
							termSibling.classList.add('active');
							termSibling.style.height = 'auto';
			
							var height = termSibling.clientHeight + 'px';
			
							termSibling.style.height = '0px';
			
							setTimeout(function () {
							termSibling.style.height = height;
							}, 0);
							
						} else {
							
							termSibling.style.height = '0px';
			
							termSibling.addEventListener('transitionend', function () {
							termSibling.classList.remove('active');
							}, {
							once: true
							});
							
						}
			
							event.preventDefault();
					});
				});
			
			}
			dlToggle();
	
	});
});
